import React, {useEffect} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck} from '@fortawesome/free-solid-svg-icons'
import {isValidRegExpPattern} from '../../Utils/Validations/MembersValidation'
import {Spacer} from '../../../Common/Components/Spacer'
import styled from '@emotion/styled'
import {MBContentNoteTypography} from '../Atoms/Typographies'
import {FlexContainer} from '../Atoms/Containers'
import {Color} from '../Styles'

const availableColor = Color.Green500
const unavailableColor = Color.Red600

type PasswordStatus = 'empty' | 'available' | 'unavailable'

const iconSize = 1
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: ${iconSize}rem;
  margin: auto 0;
`

type PasswordRuleTextProps = {
  ruleText: string
  password: string
  rule: RegExp
  onRuleValidate: (isValid: boolean) => void
}

export function PasswordRuleText(props: PasswordRuleTextProps): JSX.Element {
  useEffect(() => {
    props.onRuleValidate(isValidRegExpPattern(props.password, props.rule))
  }, [props.password])

  const status = getPasswordStatus(props.password, props.rule)

  return (
    <FlexContainer>
      {
        status === 'available' &&
        <StyledFontAwesomeIcon
          data-testid="check-icon"
          color={availableColor}
          icon={faCheck}
        />
      }
      <Spacer mt={'2px'} ml={status !== 'available' ? `${iconSize*10 + 3}px` : `3px`}>
        <MBContentNoteTypography color={getTextColor(status)}>
          {props.ruleText}
        </MBContentNoteTypography>
      </Spacer>
    </FlexContainer>
  )
}

const getPasswordStatus = (password: string, rule: RegExp): PasswordStatus => {
  if (password === '') {
    return 'empty'
  }

  return isValidRegExpPattern(password, rule) ? 'available' : 'unavailable'
}

const getTextColor = (status: PasswordStatus): string => {
  switch (status) {
    case 'empty':
      return ''
    case 'available':
      return availableColor
    case 'unavailable':
      return unavailableColor
    default:
      return ''
  }
}
